import { Controller } from "@hotwired/stimulus"

// A group of checkboxes at least one of which has to be ticked. `required` on a checkbox asks for that
// box itself, so the group reports its own validity through the first option: the browser then refuses
// the submission and shows the message beside it, the way it does for a required field.
export default class extends Controller {
  static targets = ["option"]
  static values = { message: String }

  connect() {
    this.update()
  }

  update() {
    const message = this.optionTargets.some(option => option.checked) ? "" : this.messageValue

    this.optionTargets[0].setCustomValidity(message)
  }
}
